import { Typography } from '@mui/material';
import {
  CustomBodyCell,
  CustomTable,
  CustomTableContainer,
  CustomTableRow,
} from '@components/Styles/TableStyle';
import {
  CustomTextField,
  SectionWrapper,
} from '@components/Styles/CommonStyle';
import React, { useState } from 'react';
import { TableBody } from '@mui/material';
import CompanyAccountCreateTablePhoneList from './CompanyAccountCreateTablePhoneList';
import { CustomButton } from '@components/Styles/ButtonStyle';
import { CustomStack } from '@components/Styles/CommonStyle';
import { theme } from '@components/Styles/theme';


// 핸드폰번호 하이픈 처리(000-0000-0000)
export const formatNumberNumber = (value) => {
  // 숫자만 남기기
  const onlyNums = value.replace(/[^0-9]/g, '');
  // 하이픈 포맷 적용
  if (onlyNums.length < 4) return onlyNums;
  if (onlyNums.length < 7) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3)}`;
  }
  if (onlyNums.length <= 11) {
    return `${onlyNums.slice(0, 3)}-${onlyNums.slice(3, 7)}-${onlyNums.slice(7)}`;
  }
  return onlyNums.slice(0, 3) + '-' + onlyNums.slice(3, 7) + '-' + onlyNums.slice(7, 11);
};

// 핸드번호 하이픈 처리하고 화면에 셋팅
export const mobileNumberChange = (value) => {  
  return formatNumberNumber(value);
};

const CompanyAccountCreateTablePhone = React.memo(({ contactList, setContactList, contactParam, setContactParam }) => {

  // 검색
  const [search, setSearch] = useState(false);
  const [searchParam, setSearchParam] = useState('');
  const [searchList, setSearchList] = useState([]);
  const [mobile, setMobile] = useState('');

  // 연락처 등록
  const handleContactRegister = () => {  
    if(contactList.length > 0){
      const lastIndex = contactList.length - 1;
      contactParam.id = contactList[lastIndex].id + 1;
    }    

    contactParam.mobile = mobile;

    if(search === true){
      setSearchList([...searchList, contactParam]);
    }  
    setContactList([...contactList, contactParam]);
    setContactParam({ name: '', duty: '', phone: '', mobile: '', email: '', id: '' });    
  };


  // 검색 조회
  const handleSearch = () => {
    if(searchParam !== ''){
      setSearch(true);
      setSearchList(
        contactList.filter((contact) => contact.name.includes(searchParam) || contact.mobile.includes(searchParam)),
      );
    }else{
      setSearch(false);
    }
  };

  return (
    <React.Fragment>
      <SectionWrapper>
        <CustomStack mb={2}>
          <Typography sx={theme.typography.h4}>연락처</Typography>
        </CustomStack>

        <CustomStack mb={2}>
          <CustomTextField
            placeholder="성명 또는 휴대전화 번호를 입력하세요"
            value={searchParam}
            onChange={(e) => setSearchParam(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearch();
              }
            }}
          />
          <CustomButton size="small" onClick={handleSearch}>
            검색
          </CustomButton>
        </CustomStack>
        <CustomStack mb={2}>
          <CustomTableContainer>
            <CustomTable>
              <TableBody>
              <CustomTableRow>
                    <CustomBodyCell>
                    <CustomTextField
                    value={contactParam.name}
                      onChange={(e) => setContactParam({ ...contactParam, name: e.target.value })}
                    />
                  </CustomBodyCell>
                  <CustomBodyCell>
                    <CustomTextField
                      value={contactParam.duty}
                      onChange={(e) => setContactParam({ ...contactParam, duty: e.target.value })}
                    />
                  </CustomBodyCell>
                  <CustomBodyCell>
                    <CustomTextField
                      value={contactParam.phone}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          setContactParam({ ...contactParam, phone: value });
                        }
                      }}
                    />
                  </CustomBodyCell>
                  <CustomBodyCell>
                    <CustomTextField
                      value={mobile}
                      placeholder="010-0000-0000"
                      inputProps={{ maxLength: 13 }} 
                      onChange={(e) => {                        
                        setMobile(mobileNumberChange( e.target.value ))}
                      }
                    />
                  </CustomBodyCell>
                  <CustomBodyCell>
                    <CustomTextField
                      value={contactParam.email}
                      onChange={(e) => setContactParam({ ...contactParam, email: e.target.value })}
                    />
                  </CustomBodyCell>
                  <CustomBodyCell align="center">
                    <CustomButton size="small" onClick={handleContactRegister}>
                      등록
                    </CustomButton>
                  </CustomBodyCell>
                </CustomTableRow>
              </TableBody>
            </CustomTable>
          </CustomTableContainer>
        </CustomStack>
        <CustomTableContainer>
          <CompanyAccountCreateTablePhoneList 
                  contactList={contactList}
                  setContactList={setContactList}
                  searchList={searchList}
                  setContactParam={setContactParam}
                  setSearchList={setSearchList}
                  search={search}
                  contactParam={contactParam}
                 />
        </CustomTableContainer>
      </SectionWrapper>
    </React.Fragment>
  );
});

export default CompanyAccountCreateTablePhone;

